import { render, staticRenderFns } from "./vipv.vue?vue&type=template&id=2d31acdc&"
import script from "./vipv.vue?vue&type=script&lang=js&"
export * from "./vipv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports